/*
  Botón "Agregar mi regalo" del carrito lateral (2026-08-17).

  Antes el banner llevaba a la colección de Mini Colecciones y el cliente tenía que
  salir del carrito, elegir una y agregarla. Ahora la agrega de un clic sin salir.

  El escucha va delegado en el documento a propósito: el carrito lateral se vuelve a
  dibujar con innerHTML en cada cambio, y eso no re-ejecuta los scripts que haya
  dentro. Un escucha directo en el botón moriría en el primer refresco.

  Quién decide el precio no es esto: el regalo cuesta $12.990 y queda en $0 por el
  descuento automático MINI-COLECCIONES de la tienda, que exige otro producto en el
  carrito. Por eso el Liquid del banner solo muestra el botón cuando ya hay uno.
*/
(function () {
  document.addEventListener('click', function (evento) {
    var boton = evento.target.closest ? evento.target.closest('.ins-cart-mc-banner__cta') : null;
    if (!boton) return;

    evento.preventDefault();
    if (boton.getAttribute('aria-busy') === 'true') return;
    boton.setAttribute('aria-busy', 'true');

    var carrito = document.querySelector('cart-drawer');
    var cuerpo = { items: [{ id: Number(boton.dataset.varianteRegalo), quantity: 1 }] };

    if (carrito && carrito.getSectionsToRender) {
      cuerpo.sections = carrito.getSectionsToRender().map(function (s) { return s.id; });
      cuerpo.sections_url = window.location.pathname;
    }

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(cuerpo),
    })
      .then(function (r) { return r.json(); })
      .then(function (respuesta) {
        // Shopify devuelve status cuando el add falla (agotado, por ejemplo).
        if (respuesta.status) {
          boton.removeAttribute('aria-busy');
          return;
        }
        if (carrito && carrito.renderContents) carrito.renderContents(respuesta);
        else window.location.reload();
      })
      .catch(function () {
        boton.removeAttribute('aria-busy');
        window.location.reload();
      });
  });
})();
